const POPOVER_SIZE = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small",
};

export default POPOVER_SIZE;
